var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee5050;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 118,
    height: 118,
    rx: 6,
    transform: "translate(-0.393)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.149 26.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.203 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 14.65,
    cy: 14.65,
    r: 14.65
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.746)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M79.747,256A25.852,25.852,0,0,0,53.9,281.852a6.894,6.894,0,0,0,6.894,6.894H98.705a6.894,6.894,0,0,0,6.894-6.894A25.852,25.852,0,0,0,79.747,256Z",
    transform: "translate(-53.895 -256)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.be1122dda2c2399fed4a29c542866983.svg";
export { ForwardRef as ReactComponent };